import React, { memo } from 'react'

import { LIBRARY_FILTER } from 'Pods/ThreeDStudio/Store/constants'

import FilteringRadio from './Components/FilteringRadio/FilteringRadio'

function SubItems() {
  return (
    <div className="filtering-content__sub-items">
      <FilteringRadio
        id="filtering-content-all"
        keyName={LIBRARY_FILTER.GENERATED_ALL}
        label="All"
      />
      <FilteringRadio
        id="filtering-content-favorites"
        keyName={LIBRARY_FILTER.GENERATED_FAVORITES}
        label="Favorites"
      />
      <FilteringRadio
        id="filtering-content-drafts"
        keyName={LIBRARY_FILTER.GENERATED_DRAFTS}
        label="Drafts"
      />
    </div>
  )
}

export default memo(SubItems)
